import { CREATE_CONSIGNMENT_FROM_NOMINATION } from "constants/actionTypes";
import { FormikSnapshot } from "sagas/modals/util";

type NominationFormValues = object;

export interface CreateConsignmentFromNominationAction {
  type: typeof CREATE_CONSIGNMENT_FROM_NOMINATION;
  nominationId: string;

  // Optional Formik Snaphot. When provided this snapshot will be restored to the Nomination form after the Consignment modal is closed.
  formikSnapshot?: FormikSnapshot<NominationFormValues>;
}
export function createConsignmentFromNomination(
  nominationId: string,
  formikSnapshot?: FormikSnapshot<NominationFormValues>,
): CreateConsignmentFromNominationAction {
  return {
    type: CREATE_CONSIGNMENT_FROM_NOMINATION,
    nominationId,
    formikSnapshot,
  };
}
